export const collections = [
  {
    id: 'col-1',
    title: '都市情感剧全集',
    desc: '把近三年讨论度较高的都市、职场与家庭情感剧整理成一包，从已完结到更新中一应俱全，适合一次补齐。',
    count: 86,
    tags: ['都市', '情感', '已完结优先'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20collection%20cover%20art%2C%20modern%20city%20skyline%20at%20warm%20golden%20dusk%20with%20amber%20window%20lights%2C%20urban%20drama%20mood%2C%20warm%20orange%20palette%2C%20no%20text%2C%20rich%20editorial%20texture&width=800&height=600&seq=cth-col-01&orientation=landscape',
  },
  {
    id: 'col-2',
    title: '悬疑推理合集',
    desc: '以案件为主线的高口碑悬疑剧与犯罪片合集，包含单季短剧与长篇单元剧，标注了建议连看的顺序。',
    count: 64,
    tags: ['悬疑', '推理', '高口碑'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20collection%20cover%20art%2C%20moody%20foggy%20city%20bridge%20at%20night%20with%20a%20single%20warm%20amber%20lamp%2C%20mysterious%20tense%20atmosphere%2C%20crimson%20accents%2C%20no%20text%2C%20high%20contrast%20texture&width=800&height=600&seq=cth-col-02&orientation=landscape',
  },
  {
    id: 'col-3',
    title: '古装权谋合集',
    desc: '以朝堂博弈与家族兴衰为核心的古装剧合集，覆盖权谋、宫廷与江湖三条脉络，服化道口碑条目单独标出。',
    count: 47,
    tags: ['古装', '权谋', '群像'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20collection%20cover%20art%2C%20grand%20ancient%20Chinese%20palace%20hall%20at%20warm%20torchlight%2C%20deep%20crimson%20columns%20and%20golden%20details%2C%20epic%20royal%20atmosphere%2C%20no%20text%2C%20rich%20textured%20style&width=800&height=600&seq=cth-col-03&orientation=landscape',
  },
  {
    id: 'col-4',
    title: '治愈系生活合集',
    desc: '节奏舒缓、适合放松时观看的治愈剧与文艺片合集，包含乡村日常、美食与成长题材的轻松条目。',
    count: 58,
    tags: ['治愈', '文艺', '慢节奏'],
    poster:
      'https://readdy.ai/api/search-image?query=Cinematic%20collection%20cover%20art%2C%20sunny%20countryside%20house%20with%20a%20garden%20in%20warm%20golden%20light%2C%20soft%20amber%20and%20cream%20tones%2C%20calm%20healing%20atmosphere%2C%20no%20text%2C%20gentle%20editorial%20style&width=800&height=600&seq=cth-col-04&orientation=landscape',
  },
];